import { render, staticRenderFns } from "./InvoiceOrderDetail.vue?vue&type=template&id=5750cfc9&scoped=true&"
import script from "./InvoiceOrderDetail.vue?vue&type=script&lang=js&"
export * from "./InvoiceOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5750cfc9",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VDivider,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5750cfc9')) {
      api.createRecord('5750cfc9', component.options)
    } else {
      api.reload('5750cfc9', component.options)
    }
    module.hot.accept("./InvoiceOrderDetail.vue?vue&type=template&id=5750cfc9&scoped=true&", function () {
      api.rerender('5750cfc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invoice/components/InvoiceOrderDetail.vue"
export default component.exports